import BaseModel from '../core/BaseModel'
export default class OfficeTPLModel extends BaseModel {

    constructor() {
        super({ 
                name: "office_tpl",
                tableName: 'office_tpl', 
                label: "Quản lý văn phòng", 
                display_key: 'name', 
                default_order: { key: 'id', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                width :4,
                class: "center",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Int", 
                label: 'ID', 
                primaryKey: true, 
                // edit: {
                //     add: false, 
                //     edit: false 
                // }, 
                display: false
            },
            code: {
                name: 'code', 
                type: "String",
                label: 'Mã văn phòng',
                width :10, 
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            name: {
                name: 'name', 
                type: "String",
                label: 'Tên văn phòng',
                width :15, 
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            address: {
                name: 'address', 
                type: "String",
                label: 'Địa chỉ',
                width :15, 
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            tax_code: {
                name: 'tax_code', 
                type: "String",
                label: 'Mã số thuế',
                width :10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            phone: {
                name: 'phone', 
                type: "String",
                label: 'Số điện thoại',
                width :10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
        },)
    }

}